// Every project on the site. Text lives in locales/<lang>/ProjectsDetails.json
// under the project's `key`; this file holds what doesn't change with language.
// URLs use the slug (/project/oxipos). Ids 1-8 are the old numeric URLs, which
// still resolve and redirect to the slug so existing links keep working.

export const projects = [
  {
    id: 7,
    key: "oxipos",
    slug: "oxipos",
    kind: "product",
    brand: { accent: "#EB9B29", surface: "#0E1730", block: "/assets/projects/oxipos/oxipos-block.jpg" },
    client: "Oxide",
    cover: "/assets/projects/oxipos/hero-{lang}.jpg",
    coverDark: true,
    platforms: ["iOS", "Android", "macOS", "Web"],
    stack: ["Flutter", "Django", "PostgreSQL", "AWS ECS", "Terraform"],
    links: [
      { type: "appstore", url: "https://apps.apple.com/app/oxipos/id6476778553" },
      { type: "playstore", url: "https://play.google.com/store/apps/details?id=com.oxidetech.oxipos" },
      { type: "web", url: "https://app.oxipos.oxide-digital.com", label: "app.oxipos.oxide-digital.com" },
    ],
    gallery: [
      { image: "/assets/projects/oxipos/sell.jpg", section: 1 },
      { image: "/assets/projects/oxipos/stock.jpg", section: 2 },
      { image: "/assets/projects/oxipos/reports.jpg", section: 3 },
      // bleed: the image carries its own backdrop, so it fills the panel edge to edge.
      { image: "/assets/projects/oxipos/phone-staff.jpg", section: 4, bleed: true },
    ],
  },
  {
    id: 1,
    key: "posa",
    slug: "posa-sport",
    kind: "product",
    brand: { accent: "#D4F53C", surface: "#0C0D0F", block: "/assets/projects/posa/posa-block.jpg" },
    client: "Oxide",
    cover: "/assets/projects/posa/posa-cover.jpg",
    coverDark: true,
    platforms: ["iOS", "Android"],
    stack: ["Flutter", "Cloud Firestore", "Google Maps"],
    links: [
      { type: "appstore", url: "https://apps.apple.com/us/app/posa-sport/id6746412980" },
      { type: "playstore", url: "https://play.google.com/store/apps/details?id=com.oxidedigital.posa" },
      { type: "web", url: "https://www.posasport.com", label: "posasport.com" },
    ],
    gallery: [
      { image: "/assets/projects/posa/posa-map.jpg", section: 1 },
      { image: "/assets/projects/posa/posa-explore.jpg", section: 2 },
      { image: "/assets/projects/posa/posa-bookings.jpg", section: 3 },
    ],
  },
  {
    // Private platform: no public link, and every screenshot uses demo data.
    id: 8,
    key: "accounting",
    slug: "accounting-platform",
    kind: "private",
    cover: "/assets/projects/accounting/acct-dashboard.jpg",
    coverDark: true,
    platforms: ["Web"],
    stack: ["Next.js", "TypeScript", "AWS Lambda", "Aurora PostgreSQL", "Cognito", "AWS CDK"],
    links: [],
    gallery: [
      { image: "/assets/projects/accounting/acct-dashboard.jpg", section: 1, bleed: true },
      { image: "/assets/projects/accounting/acct-invoices.jpg", section: 2, bleed: true },
      { image: "/assets/projects/accounting/acct-profit-loss.jpg", section: 3, bleed: true },
      { image: "/assets/projects/accounting/acct-tax.jpg", section: 4, bleed: true },
    ],
  },
  {
    id: 2,
    key: "observatory",
    slug: "domestic-violence-observatory",
    kind: "client",
    client: "MADRE",
    cover: "/assets/projects/madre/dvobsdash.png",
    platforms: ["Mobile", "Web"],
    stack: [],
    links: [{ type: "web", url: "https://violences-domestiques-rdc.org", label: "violences-domestiques-rdc.org" }],
    gallery: [
      { image: "/assets/projects/madre/dvobscollect.png", section: 1 },
      { image: "/assets/projects/madre/collectweb.png", section: 2 },
      { image: "/assets/projects/madre/dvobsweb.png", section: 3 },
      { image: "/assets/projects/madre/dvobsdash.png", section: 4 },
    ],
  },
  {
    id: 5,
    key: "siso",
    slug: "step-in-step-out",
    kind: "client",
    client: "Step In, Step Out",
    cover: "/assets/projects/stepinstepout/sisomain.png",
    platforms: ["Web"],
    stack: ["Next.js", "TypeScript", "Firestore", "D3.js"],
    links: [{ type: "web", url: "https://stepinstepout-virtual.com", label: "stepinstepout-virtual.com" }],
    gallery: [
      { image: "/assets/projects/stepinstepout/sisoparticipant.png", section: 1 },
      { image: "/assets/projects/stepinstepout/sisofacilitator.png", section: 2 },
      { image: "/assets/projects/stepinstepout/sisovisualization.png", section: 3 },
      { image: "/assets/projects/stepinstepout/sisoanalytics.png", section: 4 },
    ],
  },
  {
    id: 4,
    key: "cecfpi",
    slug: "cec-fpi",
    kind: "client",
    client: "CEC-FPI · Swisscontact",
    cover: "/assets/projects/cecfpi/cecwebsite.png",
    platforms: ["Web"],
    stack: [],
    links: [{ type: "web", url: "https://cec-fpi.org", label: "cec-fpi.org" }],
    gallery: [
      { image: "/assets/projects/cecfpi/cecwebsite.png", section: 1 },
      { image: "/assets/projects/cecfpi/cecdash.png", section: 2 },
    ],
  },
  {
    id: 6,
    key: "devopsquest",
    slug: "devopsquest",
    kind: "client",
    client: "DevOpsQuest",
    cover: "/assets/projects/devopsquest/dqmain.png",
    platforms: ["Web"],
    stack: ["Next.js", "TypeScript", "Firebase", "Netlify"],
    links: [{ type: "web", url: "https://devopsquest.dev", label: "devopsquest.dev" }],
    gallery: [
      { image: "/assets/projects/devopsquest/dqmobile.png", section: 1 },
      { image: "/assets/projects/devopsquest/dqdashboard.png", section: 2 },
      { image: "/assets/projects/devopsquest/dqtrack.png", section: 3 },
      { image: "/assets/projects/devopsquest/dqauth.png", section: 4 },
    ],
  },
  {
    id: 3,
    key: "hearings",
    slug: "community-hearings",
    kind: "client",
    client: "Community Hearings",
    cover: "/assets/projects/iraq/comunityiraq.png",
    platforms: ["Web"],
    stack: ["WordPress", "Multilingual CMS"],
    links: [{ type: "web", url: "http://communityhearings.org/", label: "communityhearings.org" }],
    gallery: [{ image: "/assets/projects/iraq/comunityiraq.png", section: 1 }],
  },
];

export const products = projects.filter((p) => p.kind === "product");

// Work we built rather than sell: client projects and private platforms.
export const clientProjects = projects.filter((p) => p.kind !== "product");

// Who the project was for, as shown on cards and case studies.
export const ownerLabel = (project, tc) =>
  project.kind === "product" ? tc("kind.product") : project.kind === "private" ? tc("kind.private") : project.client;

export const projectById = (id) => projects.find((p) => p.id === Number(id));

// Accepts a slug or an old numeric id.
export const findProject = (param) => projects.find((p) => p.slug === param) ?? (/^\d+$/.test(param ?? "") ? projectById(param) : undefined);

export const projectPath = (project) => `/project/${project.slug}`;

export const coverFor = (project, lang) => project.cover.replace("{lang}", lang === "fr" ? "fr" : "en");
